import { render, staticRenderFns } from "./videoCover.vue?vue&type=template&id=42b4b78d&scoped=true&"
import script from "./videoCover.vue?vue&type=script&lang=js&"
export * from "./videoCover.vue?vue&type=script&lang=js&"
import style0 from "./videoCover.vue?vue&type=style&index=0&id=42b4b78d&prod&scoped=true&lang=less&"
import style1 from "./videoCover.vue?vue&type=style&index=1&id=42b4b78d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b4b78d",
  null
  
)

export default component.exports